import React from 'react';

const MyItems = () => {
    return (
        <div>
           <h1>I am My Items page</h1> 
        </div>
    );
};

export default MyItems;